module.exports = "<prg-select-button-interaction [device]=\"(device | async)\" [button]=\"(button | async)\" [events]=\"(events | async)\" (selected)=\"interactionSelected($event)\"></prg-select-button-interaction>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/quickstarts/quickstart-lights/select-light-interaction/select-light-interaction.component.html
// module id = 1577
// module chunks = 2